import script from "./Time.vue?vue&type=script&setup=true&lang=js"
export * from "./Time.vue?vue&type=script&setup=true&lang=js"

import "./Time.vue?vue&type=style&index=0&id=23873fb6&lang=scss&scoped=true"

import exportComponent from "/Users/anxin/Documents/Vue/河南Vue网站/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23873fb6"]])

export default __exports__